// extracted by mini-css-extract-plugin
export default {"container":"SellerSignIn_container__jcDJo","ssImage":"SellerSignIn_ssImage__tj368","rotate":"SellerSignIn_rotate__QYKtf"};